"use strict";

var _slicedToArray = require("/builds/fathomio/NuaLang/nualang.com/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _mui = require("tss-react/mui");

var _material = require("@mui/material");

var _Translate = _interopRequireDefault(require("@mui/icons-material/Translate"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var useStyles = (0, _mui.makeStyles)()(function (theme) {
  return {
    menu: {
      padding: 0
    },
    formControl: {
      margin: theme.spacing(1)
    },
    group: {
      margin: theme.spacing(1)
    },
    language: {
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(2)
    }
  };
});

function SiteLanguageSelector(_ref) {
  var t = _ref.t,
      currentLanguage = _ref.currentLanguage,
      handleChangeLanguage = _ref.handleChangeLanguage,
      languageOptions = _ref.languageOptions;

  var _useStyles = useStyles(),
      classes = _useStyles.classes;

  var _react$default$useSta = _react.default.useState(currentLanguage),
      _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
      language = _react$default$useSta2[0],
      setLanguage = _react$default$useSta2[1];

  function handleChange(event) {
    var value = event.target.value;
    setLanguage(value);
    handleChangeLanguage(value);
    handleCloseMenu();
  }

  var _react$default$useSta3 = _react.default.useState(null),
      _react$default$useSta4 = _slicedToArray(_react$default$useSta3, 2),
      anchorEl = _react$default$useSta4[0],
      setAnchorEl = _react$default$useSta4[1];

  var open = Boolean(anchorEl);

  function handleMenu(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleCloseMenu() {
    setAnchorEl(null);
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
    title: t('change_language'),
    enterDelay: 300
  }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    color: "inherit",
    "aria-label": t('change_language'),
    "aria-haspopup": "true",
    onClick: handleMenu,
    size: "large"
  }, /*#__PURE__*/_react.default.createElement(_Translate.default, null))), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.language
  }, language.toUpperCase()), /*#__PURE__*/_react.default.createElement(_material.Menu, {
    id: "menu-appbar",
    className: classes.menu,
    anchorEl: anchorEl,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    keepMounted: true,
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    open: open,
    onClose: handleCloseMenu
  }, /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    component: "fieldset",
    className: classes.formControl
  }, /*#__PURE__*/_react.default.createElement(_material.FormLabel, {
    component: "legend"
  }, t("language")), /*#__PURE__*/_react.default.createElement(_material.RadioGroup, {
    "aria-label": "language",
    name: "language",
    className: classes.group,
    value: language,
    onChange: handleChange
  }, languageOptions.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
      value: option.value,
      control: /*#__PURE__*/_react.default.createElement(_material.Radio, null),
      label: option.label
    });
  })))));
}

SiteLanguageSelector.propTypes = {};
SiteLanguageSelector.defaultProps = {
  languageOptions: [{
    value: 'en',
    label: 'English'
  }, {
    value: 'en-US',
    label: 'English US'
  } // {
  //   value: 'it',
  //   label: 'Italiano'
  // },
  // {
  //   value: 'de',
  //   label: 'Deutsche'
  // },
  // {
  //   value: 'ga',
  //   label: 'Gaeilge'
  // },
  // {
  //   value: 'pt',
  //   label: 'Portugues'
  // },
  // {
  //   value: 'fr',
  //   label: 'Français'
  // },
  // {
  //   value: 'es',
  //   label: 'Español'
  // },
  ]
};

var _default = exports.default = SiteLanguageSelector;